// Click-to-highlight for every table row in the app, via a single delegated
// listener instead of touching every table component individually. Data
// Absensi and Data Payroll are excluded -- they already have their own
// Vue-reactive per-table highlight (backgroundRed/setBg), and stacking this
// on top would just fight it.
const EXCLUDED_PATH_PREFIXES = ['/data-absensi', '/data-payroll'];

export function initRowHighlight() {
  document.addEventListener('click', function(e) {
    if (EXCLUDED_PATH_PREFIXES.some(function(prefix) { return window.location.pathname.startsWith(prefix); })) {
      return;
    }

    const tr = e.target.closest('tbody tr');
    if (!tr) {
      return;
    }

    const tbody = tr.parentElement;
    const wasHighlighted = tr.classList.contains('row-highlighted');
    // Only one highlighted row per table at a time -- clear siblings in
    // this tbody before (possibly) re-adding it to the clicked row.
    tbody.querySelectorAll(':scope > tr.row-highlighted').forEach(function(el) {
      el.classList.remove('row-highlighted');
    });
    if (!wasHighlighted) {
      tr.classList.add('row-highlighted');
    }
  });
}
